import ReactPaginate from "react-paginate";

export function PaginatedItems({ pageCount, setCurrentPage }) {
    const handlePageClick = (event) => {
        setCurrentPage(event.selected + 1);
    };

    return (
        <ReactPaginate
            nextLabel=">"
            previousLabel="<"
            onPageChange={handlePageClick}
            pageRangeDisplayed={3}
            marginPagesDisplayed={2}
            pageCount={pageCount}
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakLabel="..."
            breakClassName="page-item"
            breakLinkClassName="page-link"
            containerClassName="pagination"
            activeClassName="active"
            renderOnZeroPageCount={true}
        />
    );
}
